import { render } from "./ContentblockAgenda.vue?vue&type=template&id=32f08908&scoped=true&ts=true"
import script from "./ContentblockAgenda.ts?vue&type=script&lang=ts"
export * from "./ContentblockAgenda.ts?vue&type=script&lang=ts"

import "./ContentblockAgenda.scss?vue&type=style&index=0&id=32f08908&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f08908"]])

export default __exports__